import React, { Component } from 'react';
import ViewState from "./ViewState";

class About extends Component {
    componentWillMount() {
        this.props.appState.viewState = ViewState.about;
    }

    render() {
        return (
            <div className="about box-shadow">
                <div className="row about-text">
                    <h2><img className="cg-about-coingrasp" src="/images/coingrasp-logo.svg" alt="CoinGrasp logo"/> About CoinGrasp</h2>
                    <br />
                    <p>CoinGrasp is a site that shows a real-time overview of the crypto currency market.
                        We also aim to give you simple descriptions of every coin so you can get a better understanding of the coins.</p>
                    <br/>
                    <p>If you have any feedback or feature requests, please contact us at hello@coingrasp.com</p>
                </div>
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/About.js